import { render } from "./EntryQuestionWait.vue?vue&type=template&id=068aa6d0"
import script from "./EntryQuestionWait.vue?vue&type=script&lang=js"
export * from "./EntryQuestionWait.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src882003474/src/vote-screen-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__